import {
    Component,
    Optional,
    Inject,
    Input,
    ViewChild,
} from '@angular/core';
  
import {
    NgModel,
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    NG_ASYNC_VALIDATORS,
} from '@angular/forms';
  
import {ElementBase, animations} from '../';
  
@Component({
    selector: 'itpx-controls-multi-select',
    templateUrl: './multi-select.component.html',
    styleUrls: [ './multi-select.component.css' ],
    animations,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: ControlsMultiSelectComponent,
        multi: true,
    }],
})
export class ControlsMultiSelectComponent extends ElementBase<string[]> {
    @Input() public placeholder: string;
    @Input() public reverse: boolean;
    @Input() public formatDisplayValue: any;
    private disabled: boolean;

    @ViewChild(NgModel) model: NgModel;

    constructor(
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
    ) {
        super(validators, asyncValidators);
    }

    private onSelect(event: any) {
        let item = event.target.value;
        event.target.value = '';
        if (!item || this.value.indexOf(item, 0) !== -1) return;
        let items = [];

        this.value.forEach(element => {
            items.push(element);
        });
        
        if(this.reverse) {
            items.push(item);
        } else {
            items.unshift(item);
        }

        this.value = items;
    }

    private onRemove(item: string) {
        let items = this.value.slice();
        let index = this.value.indexOf(item, 0);
        if (index > -1) items.splice(index, 1);
        this.value = items;
    }

    setDisabledState(isDisabled : boolean) : void {
        this.disabled = isDisabled;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/controls/multi-select/multi-select.component.ts